import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { axios } from 'lib/axios';
import { listParams, qnaKey } from './queryKeys';

const getDraftNotifications = (resource, id, paging) =>
  axios.get(`/api/${resource}/${id}/qna/notifications/drafts`, { params: listParams(paging) });

export const useDraftNotifications = (resource, id, paging, options = {}) =>
  useQuery({
    queryKey: qnaKey(resource, id, 'drafts', paging.page, paging.pageSize, paging.order),
    queryFn: () => getDraftNotifications(resource, id, paging),
    select: ({ data }) => ({ items: data.data, total: data.total }),
    placeholderData: keepPreviousData,
    ...options,
  });
